export class CreateJobworkModel {
    jobworkId: number;
    division: string;
    unit: number;
    subJobId: number;
    buyer: string;
    operationType: string;
    styleNo: string;
    itemNo: string;
    addonOrderQty: number;
    totalOrderQty: number;
    addOnQtyDate: Date;
    noOfOperations: number;
    ratePerGarment: string;

    constructor(
        jobworkId: number,
        division: string,
        unit: number,
        subJobId: number,
        buyer: string,
        operationType: string,
        styleNo: string,
        itemNo: string,
        addonOrderQty: number,
        totalOrderQty: number,
        addOnQtyDate: Date,
        noOfOperations: number,
        ratePerGarment: string
    ) {
        this.jobworkId = jobworkId;
        this.division = division;
        this.unit = unit;
        this.subJobId = subJobId;
        this.buyer = buyer;
        this.operationType = operationType;
        this.styleNo = styleNo;
        this.itemNo = itemNo;
        this.addonOrderQty = addonOrderQty;
        this.totalOrderQty = totalOrderQty;
        this.addOnQtyDate = addOnQtyDate;
        this.noOfOperations = noOfOperations;
        this.ratePerGarment = ratePerGarment;
    }
}
